import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
// import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Get_All_Catagory } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import {
  Get_Strategy_BY_Id,
  Edit_Strategy,
} from "../../../../ReduxStore/Slice/Admin/StrategySlice";
import toast, { Toaster } from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
const EditStrategyNormal = () => {
  const user_token = JSON.parse(localStorage.getItem("user_details")).token;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [CatagoryData, setCatagoryData] = useState({
    loading: true,
    data: [],
  });

  const indicatorList = [
    "RSI",
    "BollingerBand",
    "Supertrend",
    "Moving Average",
    "MACD",
    "Parabolic SAR",
    "Fractals",
    "Stochastic Oscillator",
    "ATR",
    "Envelopes",
  ];

  const [one_strategy, setone_strategy] = useState("");

  const formik = useFormik({
    initialValues: {
      strategyname: "",

      segment: "Crypto",

      strategy_description: "",
        starategylogo: "",
      indecator: "",
    },
    touched: {
      strategyname: false,

      segment: false,

      strategy_description: false,
    },
    validate: (values) => {
      const errors = {};
      if (!values.strategyname && formik.touched.strategyname) {
        errors.strategyname = valid_err.EMPTY_STRATEGY_NAME_ERR;
      }

   
      if (!values.strategy_description && formik.touched.strategy_description) {
        errors.strategy_description = valid_err.EMPTY_STRATEGY_DESCRIPTION_ERR;
      }else if (values.strategy_description.length < 100) {
        errors.strategy_description = "Description must be at least 100 characters long.";
      }

      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        _id: id,
        strategy_name: values.strategyname,

        strategy_segment: "Crypto",
        strategy_description: values.strategy_description,
         strategy_indicator: values.indecator,     
        strategy_image: values.starategylogo,
      };

      await dispatch(Edit_Strategy({ req: req, token: user_token }))
        .unwrap()
        .then((response) => {
          if (response.status === 409) {
            toast.error(response.data.msg);
          } else if (response.status) {
            toast.success(response.msg);
            setTimeout(() => {
              navigate("/subadmin/strategies");
            }, 1000);
          }
        });
    },
  });

  const fields = [
    {
      name: "strategyname",
      label: "Strategy Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: false,
    },

  {
      name: "indecator",
      label: "Strategy Indicator",
      type: "text",
      col_size: 6,
      label_size: 6,
      list: "indicator-list",  
    },

    {
      name: "starategylogo",
      label: "Strategy Logo (Image)",
      type: "file",
      label_size: 12,
      col_size: 12,
    },

    {
      name: "strategy_description",
      label: "Strategy Description",
      type: "msgbox",
      row_size: 7,
      label_size: 6,
      col_size: 6,
      disable: false,
    },
  ];

  const getservice = async () => {
    await dispatch(Get_All_Catagory())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setCatagoryData({
            loading: false,
            data: response.data,
          });
        }
      });
  };
  useEffect(() => {
    getservice();
  }, []);

  const get_strategy_BY_did = async () => {
    await dispatch(
      Get_Strategy_BY_Id({
        _id: id,
        token: user_token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          formik.setFieldValue("strategyname", response.data.strategy_name);

          formik.setFieldValue("segment", response.data.strategy_segment);

          formik.setFieldValue(
            "strategy_description",
            response.data.strategy_description
          );
        }
      });
  };
  useEffect(() => {
    get_strategy_BY_did();
  }, [id]);

  return (
    <>
      <Content
        Page_title="Edit Strategy "
        button_title="Back"
        route="/subadmin/strategies"
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Edit Strategy"
          title="EditStrategy"
        />
        <ToastButton />
      </Content>
    </>
  );
};

export default EditStrategyNormal;
